<template>
  <div id="basic">
    <el-row :gutter="20">
      <el-col :span="24">
        <div style="display: flex">
          <div style="margin-right: 20px">选择门店：</div>
          <el-select
            v-model="formInline.id"
            placeholder="请选择"
            @change="getList"
          >
            <el-option
              v-for="index in typeDate"
              :key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :lg="12" :md="12">
        <el-card shadow="hover" class="cardMaxBox">
          <div class="topBox">
            <div class="titleColor">
              <i class="el-icon-s-marketing"></i> 本月数据
            </div>
            <div class="perCapita">
              人均消费：¥{{ topValue['per_client_sale' + getDate()] || 0 }}
            </div>
          </div>

          <div class="bottomBox">
            <div class="item">
              <p class="number">
                {{ topValue['total_sale' + getDate()] || 0 }}
              </p>
              <p>销售额</p>
            </div>
            <div class="item">
              <p class="number">
                {{ topValue['prepay_sale' + getDate()] || 0 }}
              </p>
              <p>充值额</p>
            </div>
            <div class="item">
              <p class="number">
                {{ topValue['member_sale' + getDate()] || 0 }}
              </p>
              <p>会员余额消费</p>
            </div>
          </div>
          <div class="payBox">
            <div class="itemflxe">
              <div class="weChatJd">
                微信消费金额: {{ topValue['wechat_sale' + getDate()] || 0 }}
              </div>
            </div>
            <div class="itemflxe">
              <div class="AlPayJd">
                支付宝消费金额: {{ topValue['ali_sale' + getDate()] || 0 }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :lg="12" :md="12">
        <el-card shadow="hover" class="cardMaxBox">
          <div class="topBox">
            <div class="onTitleColor">
              <i class="el-icon-s-marketing"></i> 上月数据
            </div>
            <div class="perCapita">
              人均消费：¥{{ topValue['per_client_sale' + fastDate()] || 0 }}
            </div>
          </div>

          <div class="bottomBox">
            <div class="item">
              <p class="number">
                {{ topValue['total_sale' + fastDate()] || 0 }}
              </p>
              <p>销售额</p>
            </div>
            <div class="item">
              <p class="number">
                {{ topValue['prepay_sale' + fastDate()] || 0 }}
              </p>
              <p>充值额</p>
            </div>
            <div class="item">
              <p class="number">
                {{ topValue['member_sale' + fastDate()] || 0 }}
              </p>
              <p>会员余额消费</p>
            </div>
          </div>
          <div class="payBox">
            <div class="itemflxe">
              <div class="weChatJd">
                微信消费金额: {{ topValue['wechat_sale' + fastDate()] || 0 }}
              </div>
            </div>
            <div class="itemflxe">
              <div class="AlPayJd">
                支付宝消费金额:{{ topValue['member_sale' + fastDate()] || 0 }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['total_sale' + getDate()]||0 }}K
            </div>
            <div class="item_name">本月销售额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['prepay_sale' + getDate()]||0 }}
            </div>
            <div class="item_name">本月充值额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">{{ topValue['ali_sale' + getDate()]||0 }}</div>
            <div class="item_name">本月支付宝消费金额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['wechat_sale' + getDate()]||0 }}
            </div>
            <div class="item_name">本月微信消费金额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['member_sale' + getDate()]||0 }}
            </div>
            <div class="item_name">本月会员余额消费</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['per_client_sale' + getDate()]||0 }}
            </div>
            <div class="item_name">本月客单价</div>
          </div>
        </div>
      </el-col> -->
    </el-row>
    <!-- <el-row :gutter="20">
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['total_sale' + fastDate()]||0 }}K
            </div>
            <div class="item_name">上月销售</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['prepay_sale' + fastDate()]||0 }}
            </div>
            <div class="item_name">上月充值额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['ali_sale' + fastDate()]||0 }}
            </div>
            <div class="item_name">上月支付宝消费金额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['wechat_sale' + fastDate()]||0 }}
            </div>
            <div class="item_name">上月微信消费金额</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['member_sale' + fastDate()]||0 }}
            </div>
            <div class="item_name">上月会员余额消费</div>
          </div>
        </div>
      </el-col>
      <el-col :span="4"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_value">
              {{ topValue['per_client_sale' + fastDate()]||0 }}
            </div>
            <div class="item_name">上月客单价</div>
          </div>
        </div>
      </el-col>
    </el-row>
     -->
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back comWhitBg">
          <div id="echart_A" style="width: 100%; height: 300px"></div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back comWhitBg">
          <div id="echart_B" style="width: 100%; height: 300px"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        id: '',
        category_type: 1, // c_type|| 2外卖  1堂食
      },
      datalist: [],
      // datalist: [
      //   {
      //     indicator: {
      //       value_type: 'total_sale',
      //       date_type: 'day',
      //       is_date_range: true,
      //       date: '',
      //       date_from: '2021-06-01',
      //       date_to: '2021-06-02',
      //     },
      //     value: [
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '1',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-01',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 1213,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-02',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 13578,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-03',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 123123,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-04',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 1231,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-05',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 445454,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-06',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 3478,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-07',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 13578,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-08',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 34534,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-09',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 9667,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-10',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 13578,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-11',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 76744,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-12',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 13578,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-13',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 67676,
      //       },
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '',
      //         shop_id: 1234567,
      //         date: 20210601,
      //         date_display: '2021-06-14',
      //         date_type: 'day',
      //         value_type: 'total_sale',
      //         value: 75676,
      //       },
      //     ],
      //   },
      //   {
      //     indicator: {
      //       value_type: 'wechat_sale',
      //       date_type: 'day',
      //       is_date_range: false,
      //       date: '2021-07-01',
      //     },
      //     value: [
      //       {
      //         ID: 1234567,
      //         CreatedAt: '2020-01-19T12:24:32',
      //         UpdatedAt: '1',
      //         shop_id: 1234567,
      //         date: 20210701,
      //         date_display: '2021-07-01',
      //         date_type: 'day',
      //         value_type: 'wechat_sale',
      //         value: 13578,
      //       },
      //     ],
      //   },
      // ],
      topValue: {},
      typeDate: [],
    };
  },
  created() {
    this.$root.headName = ['运营数据', '经营分析'];
  },
  mounted() {
    this.getType();
    //
  },
  methods: {
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    drawLine() {
      let elementById = document.getElementById('echart_A');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
        value = [];
      const exlist = this.topValue['total_sale_day'];
      if (exlist) {
        exlist.map((item) => {
          data.push(item.day);
          value.push(item.total_price / 100);
        });
      }

      let option = {
        title: {
          text: '30天销售收入',
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data,
        },
        yAxis: {
          type: 'value',

          splitLine: { show: false },
        },
        series: [
          {
            name: '当日销售收入',
            type: 'line',
            color: '#ff6c37',
            stack: '总量',
            data: value,
            label: {
              show: true,
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },
    drawLines() {
      let elementById = document.getElementById('echart_B');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
        value = [];

      const exlist = this.topValue['client_stat_day'];
      if (exlist) {
        exlist.map((item) => {
          data.push(item.day);
          value.push(item.count);
        });
      }
      let option = {
        title: {
          text: '30天就餐人数',
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data,
        },
        yAxis: {
          type: 'value',

          splitLine: { show: false },
        },
        series: [
          {
            name: '当日就餐人数',
            type: 'line',
            color: '#004cff',
            stack: '总量',
            data: value,
            label: {
              show: true,
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },
    getDate(is) {
      var myDate = new Date();
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    fastDate(is) {
      var myDate = new Date(
        new Date().getTime() - 1000 * 60 * 60 * 24 * 31 * 1
      );
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    getList() {
      console.log('获取1', this.fastDate());
      console.log('获取2true', this.fastDate(true));
      console.log('getDate:true', this.getDate(true));
      console.log('getDate', this.getDate());

      const shop_id = this.formInline.id;
      // const shop_id = 25884083765760;
      const newDate = new Date().getFullYear() + 1;
      const data = {
        shop_id,
        indicators: [
          // 总销售额
          {
            value_type: 'total_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.getDate(),
          },
          {
            value_type: 'total_sale',
            date_type: 'month',
            is_date_range: false,
            date: this.fastDate(),
          },
          // 支付宝销售额
          {
            is_date_range: false,
            value_type: 'ali_sale',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'ali_sale',
            date_type: 'month',
            date: this.fastDate(),
          },
          // 微信销售额
          {
            is_date_range: false,
            value_type: 'wechat_sale',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'wechat_sale',
            date_type: 'month',
            date: this.fastDate(),
          },
          //会员充值金额 prepay_sale
          {
            is_date_range: false,
            value_type: 'prepay_sale',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'prepay_sale',
            date_type: 'month',
            date: this.fastDate(),
          },
          //会员消费余额 member_sale
          {
            is_date_range: false,
            value_type: 'member_sale',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'member_sale',
            date_type: 'month',
            date: this.fastDate(),
          },
          //客单价
          {
            is_date_range: false,
            value_type: 'per_client_sale',
            date_type: 'month',
            date: this.getDate(),
          },
          {
            is_date_range: false,
            value_type: 'per_client_sale',
            date_type: 'month',
            date: this.fastDate(),
          },
          //30天销售
          {
            value_type: 'total_sale',
            date_type: 'day',
            is_date_range: true,
            date_to: this.getDate(true),
            date_from: this.fastDate(true),
          },
          //30天就餐人数
          {
            value_type: 'client_stat',
            date_type: 'day',
            is_date_range: true,
            date_to: this.getDate(true),
            date_from: this.fastDate(true),
          },
        ],
      };

      const url = this.$userList.show_indicator;
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
          this.datalist = res.data.results;
          this.setDatalist();
        }
      });
    },
    setDatalist() {
      const data = {};
      this.datalist.map((item) => {
        if (item.indicator.date) {
          data[item.indicator.value_type + '' + item.indicator.date] =
            (item.value && item.value.total_price / 100) || 0;
        } else {
          data[item.indicator.value_type + '_' + item.indicator.date_type] =
            item.value;
        }
      });
      console.log(data);
      this.topValue = data;
      this.drawLine();
      this.drawLines();
    },
  },
};
</script>

<style lang="scss" scoped>
.cardMaxBox {
  border-radius: 30px;
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 20px 0;
  padding-bottom: 10px;
  margin-top: 20px;
  .topBox {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    .titleColor {
      color: #f74608;
    }
    .onTitleColor {
      color: #0b74b8;
    }
    .perCapita {
      padding: 0 15px;
      font-size: 14px;
      color: #0b74b8;
      border-bottom: 1px solid #0b74b8;
    }
  }
  .payBox {
    padding-top: 15px;
    display: flex;
    .itemflxe {
      display: flex;
      flex: 1;
      flex-direction: column;
      padding: 10px;
    }
    .weChatJd {
      display: flex;
      flex: 1;
      // height: 20px;
      padding: 5px 0;
      background-color: #04be02;
      color: #ffffff;
      font-size: 14px;
      border-radius: 5px;
      text-align: center;
      justify-content: center;
    }
    .AlPayJd {
      display: flex;
      flex: 1;
      // height: 20px;
      padding: 5px 0;
      background-color: #1678ff;
      color: #ffffff;
      font-size: 14px;
      border-radius: 5px;
      justify-content: center;
      text-align: center;
    }
  }
  .bottomBox {
    display: flex;

    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;
      color: #999a9a;
      font-size: 16px;
      padding-top: 30px;
      .number {
        color: #0b74b8;
        font-size: 30px;
        margin: 0;
      }
    }
  }
}
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.295); */
}
.back {
  width: 100%;
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.295);
  box-sizing: border-box;
  padding: 20px 10px;
  border-radius: 5px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fcfa;
}
.top_item {
  box-sizing: border-box;
  padding: 10px 0;
}
.item_value {
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
  width: 100%;
  text-align: center;
}
.item_name {
  font-size: 16px;
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
</style>
